import { formatDistanceStrict } from 'date-fns'

export const getDistanceTime = ({ date, addSuffix = true }) =>
  formatDistanceStrict(new Date(parseInt(date)), new Date(), {
    addSuffix
  })
